export const PENDING_EMAIL_STORAGE_KEY = 'photonium:pendingSignInEmail';
export const EMAIL_VERIFICATION_CODE_MAX_AGE_SECONDS = 10 * 60;
export const EMAIL_VERIFICATION_CODE_MAX_AGE_LABEL = '10 minutes';
